var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c("div", { staticClass: "eval-popup" }, [
        _c("div", { staticClass: "eval-popup__overlay" }),
        _vm._v(" "),
        _c("div", { staticClass: "eval-popup__wrapper" }, [
          _c("div", { staticClass: "eval-popup__info" }, [
            _c("img", {
              staticClass: "eval-popup__img",
              attrs: { src: "/images/eval-popup.png" }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "eval-popup__lead" }, [
              _vm._v(
                "Вы зашли на страницы журнала «Сибирская нефть». Пожалуйста, ответьте на несколько вопросов. Это поможет нам стать лучше, полезнее и интереснее для Вас!"
              )
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn btn-eval",
                attrs: {
                  href:
                    "https://linkis.ru/a/3b2d0589-f1a0-4889-b410-bb7717650775/",
                  target: "_blank",
                  "data-target": "eval1",
                  "data-label": "eval1",
                  "data-category": "eval"
                },
                on: { click: _vm.submit }
              },
              [_vm._v("Принять участие в опросе")]
            )
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "eval-popup__close",
            on: { click: _vm.close }
          })
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c6b8a4d6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6b8a4d6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/components/eval-popup/eval-popup.vue
// module id = 129
// module chunks = 0